import React, {useEffect} from 'react'
import {createPortal} from 'react-dom'
import './AdminAlert.css'

export function AdminAlert({message, onClose}) {
  useEffect(() => {
    if (!message) return
    const timer = window.setTimeout(() => onClose(null), 5000)
    return () => window.clearTimeout(timer)
  }, [message, onClose])

  if (!message) return null

  return createPortal(
    <div className={`admin-floating-alert alert alert-${message.type} alert-dismissible`} role='status'>
      {message.text}
      <button type='button' className='btn-close' aria-label='Cerrar' onClick={() => onClose(null)}></button>
    </div>,
    document.body
  )
}
